import React from 'react';
import toast from 'react-hot-toast';

// Duplicate toast kontrolü için - aynı mesajı kısa süre içinde sadece bir kez göster
const toastHistory = new Map();
const DEBOUNCE_TIME = 5000; // 5 saniye

const shouldShowToast = (message, toastId) => {
  const now = Date.now();
  const lastShown = toastHistory.get(toastId || message);
  
  if (!lastShown || (now - lastShown) > DEBOUNCE_TIME) {
    toastHistory.set(toastId || message, now);
    // Eski kayıtları temizle (memory leak önleme)
    if (toastHistory.size > 100) {
      const oldestKey = Array.from(toastHistory.entries())
        .sort((a, b) => a[1] - b[1])[0][0];
      toastHistory.delete(oldestKey);
    }
    return true;
  }
  return false;
};

// Sunucuya ulaşılamıyor hatası için toast
export const showServerError = () => {
  const message = 'Sunucuya ulaşılamıyor. Lütfen internet bağlantınızı kontrol edin veya tekrar deneyin.';
  const toastId = 'server-error';
  
  if (shouldShowToast(message, toastId)) {
    toast.error(message, { id: toastId });
  }
};

// Başarı mesajı için toast
export const showSuccess = (message) => {
  toast.success(message);
};

// Hata mesajı için toast — debounce
export const showError = (message) => {
  if (!shouldShowToast(message)) return;
  toast.error(message);
};

// Session timeout mesajı için toast (aynı toastId ile birden fazla 401'de tek toast)
const SESSION_TIMEOUT_TOAST_ID = 'session-timeout';

export const showSessionTimeout = () => {
  if (!shouldShowToast('session-timeout', SESSION_TIMEOUT_TOAST_ID)) return;
  
  toast.error(
    (t) => (
      <div className="d-flex align-items-center">
        <div>
          <strong>Oturum Süresi Doldu</strong>
          <div style={{ fontSize: '0.85em', marginTop: '4px' }}>Lütfen tekrar giriş yapınız.</div>
        </div>
      </div>
    ),
    {
      id: SESSION_TIMEOUT_TOAST_ID,
      duration: 3000,
      style: { border: '1px solid #fecaca', background: '#fef2f2', color: '#991b1b' },
      icon: '🔒',
    }
  );
  
  // Directly clear tokens to let AuthContext handle the redirect cleanly,
  // avoiding a hard window.location redirect which causes a flash.
  localStorage.removeItem('auth_token');
  localStorage.removeItem('auth_refresh_token');
  localStorage.removeItem('auth_user');
  
  // A clean redirect instead of '?timeout=true' params if not already on login
  if (!window.location.pathname.includes('/login')) {
    // A small timeout to let the user see the toast if they are actively using the app,
    // but without causing double redirects if AuthContext is already unmounting them.
    setTimeout(() => {
      window.location.href = '/login';
    }, 1500);
  }
};

// Bilgi mesajı için toast
export const showInfo = (message) => {
  toast(message, { icon: 'ℹ️' });
};

// Uyarı mesajı için toast
export const showWarning = (message) => {
  toast(message, { icon: '⚠️', style: { border: '1px solid #fde68a', background: '#fffbeb', color: '#92400e' } });
};

// Şirket bilgisi uyuşmazlığı hatası için toast (birden fazla 403'te tek toast)
export const showCompanyMismatchError = (message) => {
  const toastId = 'company-mismatch';
  if (!shouldShowToast('company-mismatch', toastId)) return;

  toast.error(
    (t) => (
      <div>
        <strong>Şirket Bilgisi Uyuşmuyor</strong>
        <div style={{ fontSize: '0.85em', marginTop: '4px' }}>{message || 'Bu kaynak sizin şirketinize ait değil.'}</div>
      </div>
    ),
    { id: toastId, duration: 4000 }
  );
};

// Shopify credentials hatası için toast
export const showShopifyCredentialsError = (message) => {
  const toastId = 'shopify-credentials';
  if (!shouldShowToast('shopify-credentials', toastId)) return;

  toast.error(
    (t) => (
      <div>
        <strong>Shopify Bilgileri Eksik</strong>
        <div style={{ fontSize: '0.85em', marginTop: '4px' }}>{message || 'Lütfen şirket ayarlarından bilgileri girin.'}</div>
      </div>
    ),
    { id: toastId, duration: 4000 }
  );
};

// Tüm aktif toast mesajlarını kapatmak için
export const dismissAllToasts = () => {
  toast.dismiss();
};